// @flow
import { compose, withProps } from 'react-recompose';
import { connect } from 'react-redux';
import { hasRoamingCreditableOptions } from '../../../modules/AvailableOption/selectors';
import { fetchFreeTrialActivationBonus, freeTrialActivationBonusStateSelector } from '../../../modules/Bonuses';
import {
  isNewOfferValidSelector,
  newOfferPeriodicitySelector,
  newOfferPriceSelector,
} from '../../../modules/NewOffer/selectors';
import { setVoucherDetailsComeFrom } from '../../../modules/Voucher';
import ChoosePlan from './ChoosePlan';

const mapStateToProps = (state, props) => ({
  newOfferPrice: newOfferPriceSelector(state),
  newOfferPeriodicity: newOfferPeriodicitySelector(state),
  isFreeSimPathAvailable: false,
  selectThisPlan: () => props.navigation.goBack(),
  isOfferValid: isNewOfferValidSelector(state),
  freeTrialActivationBonus: freeTrialActivationBonusStateSelector(state),
  hasRoamingOptions: hasRoamingCreditableOptions(state),
});

const mapDispatchToProps: DispatchProps = {
  setVoucherDetailsComeFrom: (comeFrom: string) => setVoucherDetailsComeFrom(comeFrom),
  fetchFreeTrial: () => fetchFreeTrialActivationBonus(),
};

const withOrderTypeProps = (): { orderType: string } => ({
  orderType: 'SUBSCRIPTION',
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withProps(withOrderTypeProps()))(ChoosePlan);
